import React from 'react';
import PropTypes from 'prop-types';

import Slide from '@material-ui/core/Slide';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PageVisibility from 'react-page-visibility';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import Backdrop from '@material-ui/core/Backdrop';
import { useTheme } from '@material-ui/core';

import { AppContext } from '../../base/AppContext';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export default function ServerChecker(props) {
  const [showDialog, setShowDialog] = React.useState(true);
  const [showRetry, setShowRetry] = React.useState(false);
  const [reloading, setReloading] = React.useState(false);
  const theme = useTheme();

  const { App } = React.useContext(AppContext);
  const classes = useStyles();

  const { server } = App;

  let reconnectInterval;
  React.useEffect(() => {
    setShowReloadTimer();
    setConnectionCheckTimer();
    App.eventsManager.on('event-connected', ServerChecker.name, () => {
      setTimeout(() => {
        handleClose();
      }, 500);
    });
    App.eventsManager.on('event-disconnected', ServerChecker.name, () => {
      setup();
    });
  }, []);

  const setup = () => {
    setConnectionCheckTimer();
    setShowDialog(true);
    setShowRetry(false);
    setReloading(false);
    setShowReloadTimer();
  };
  const setConnectionCheckTimer = () => {
    reconnectInterval = setInterval(() => {
      if (server.connected) {
        handleClose();
      } else if (showRetry) {
        server.connect();
      }
    }, 500);
  };
  const setShowReloadTimer = () => {
    if (!server.connected) {
      setTimeout(() => {
        setShowRetry(true);
      }, 8000);
    } else {
      handleClose();
    }
  };
  const handleClose = () => {
    setShowDialog(false);
    setShowRetry(false);
    clearInterval(reconnectInterval);
  };

  const handleVisibilityChange = (isVisible) => {
    if (!isVisible) {
      handleClose();
    } else {
      if (!server.connected) {
        server.connect();
        setup();
      }
    }
  };
  return (
    <PageVisibility onChange={handleVisibilityChange}>
      <Backdrop
        className={classes.backdrop}
        open={showDialog}
        onClick={handleClose}>
        <div>
          <div
            style={{
              textAlign: 'center',
            }}>
            <CircularProgress color="inherit" />
          </div>

          {showRetry && (
            <Paper
              style={{
                textAlign: 'center',
                color: theme.palette.text.primary,
                borderRadius: '10px',
                padding: '10px',
                marginTop: '19px',
              }}>
              <div style={{ marginTop: '10px' }}>
                If taking long, try reloading
              </div>

              <Button
                style={{
                  marginBottom: '10px',
                  marginTop: '10px',
                }}
                onClick={() => {
                  setReloading(true);
                  setTimeout(() => window.location.reload(), 500);
                }}
                endIcon={
                  reloading ? (
                    <CircularProgress size={12} color={'gray'} />
                  ) : (
                    <div />
                  )
                }>
                Reload
              </Button>
            </Paper>
          )}
        </div>
      </Backdrop>
    </PageVisibility>
  );
}
